<template>
  <div class="menu-button" @click="$emit('click')">
    <b-img v-if="details.iconImageSrc" :src="details.iconImageSrc" class="menu-button-icon" />
    <font-awesome-icon v-else class="menu-button-icon" :icon="details.defaultIcon" />

    <div class="menu-button-label">
      {{ details.label }}
    </div>
  </div>
</template>

<script lang="ts">
import Vue, { PropType } from 'vue'
import Component from 'vue-class-component'
import { NavButtonDetails, useNavButtonsStore } from '@/store/public/navButtons'
import { NavButtonKey } from '@/types'

const props = {
  btnKey: {
    type: String as PropType<NavButtonKey>,
    require: true,
  },
  highlight: {
    type: Boolean,
    default: false,
  },
}

@Component
export default class MenuButton extends Vue.extend({ props }) {
  navButtonsStore = useNavButtonsStore()

  get details(): NavButtonDetails {
    return this.navButtonsStore.allBtns[this.btnKey]
  }
}
</script>

<style lang="scss" scoped>
.menu-button {
  display: flex;
  align-items: center;
  gap: 12px;
  cursor: pointer;
}

.menu-button-icon {
  height: 1.3em;
  width: 1.3em;
}

.menu-button-label {
  width: 3.5em;
  font-size: 22px;
  font-weight: 200;
}
</style>
